import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/fleets/$id/cloud-storage/parent-db-sync/")({
  staticData: {
    title: "fleets.cloudStorage.parentDbSync",
  },
});
